const LOAN_TERM_TO_VALUE = {
	'15 Year Fixed': '1',
	'30 Year Fixed': '2',
	'3 ARM': '3',
	'5 ARM': '4',
	'7 ARM': '5',
	'40 Year Fixed': '6',
	'10 Year Fixed': '7',
	'20 Year Fixed': '8',
	'10 ARM': '9'
};

const PROPERTY_TYPE_TO_VALUE = {
	'Single Family': '1',
	'Multi-unit': '2',
	Condo: '3',
	Coop: '4',
	'5 to 8 story condos': '5',
	Townhome: '6',
	'Manufactured home': '7'
};

const OCCUPANCY_TYPE_TO_VALUE = {
	'Primary Residence': '1',
	'Investment Property': '2',
	'Second Home': '3'
};

function formatMortechPayload({
	additionalRequestedCash,
	creditScore,
	currentMortgageBalance,
	lenders,
	lendersList,
	loanProduct,
	occupancyType,
	offerMode,
	propertyType,
	propertyValue,
	requestedLoanAmount,
	state
}) {
	const filteredLendersList =
		lenders === 'All'
			? lendersList
			: lendersList.filter(({ lenderName }) => lenderName === lenders);
	const externalLendersList = filteredLendersList.map(
		({ externalLenderId }) => externalLenderId
	);
	const mortechProduct = LOAN_TERM_TO_VALUE[loanProduct];
	const mortechOccupancy = OCCUPANCY_TYPE_TO_VALUE[occupancyType];
	const mortechPropertyType = PROPERTY_TYPE_TO_VALUE[propertyType];
	const mortechMortgageType = offerMode === 'Purchase' ? '1' : '2';

	const mortechRateDetails = {
		additionalCashOutAmount: additionalRequestedCash,
		creditScore: creditScore,
		currentMortgageBalance: currentMortgageBalance,
		lenders: externalLendersList,
		loanAmount: requestedLoanAmount,
		loanProduct: mortechProduct,
		mortgageType: mortechMortgageType,
		occupancy: mortechOccupancy,
		propertyType: mortechPropertyType,
		propertyValue,
		stateAbbr: state
	};

	return mortechRateDetails;
}

export default formatMortechPayload;
